import React from 'react';
import { useSelector } from 'react-redux';

const SummaryCards = () => {
  const { dashboardData, loading, error } = useSelector((state) => state.dashboard);

  if (loading) return <p>Loading summary cards...</p>;
  if (error) return <p>Error loading summary data: {error}</p>;
  if (!dashboardData) return null;

  const cards = [
    { title: 'Active Pets', value: dashboardData.activePets },
    { title: 'Inactive Pets', value: dashboardData.inactivePets },
    { title: 'New Pets', value: dashboardData.newPets },
    { title: 'Total Pets', value: dashboardData.totalPets },
  ];

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      {cards.map((card, i) => (
        <div
          key={i}
          style={{
            padding: '1px 20px 20px 20px',
            background: '#e9f2ff',
            borderRadius: '16px',
            flex: 1,
          }}
        >
          <h4>{card.title}</h4>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 style={{ margin: 0 }}>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;